export default {"src":"/_next/static/media/spyglassWithCheckmark_64.f649aa5a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};